// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3Vcrw","Success":"Button_Success__9vTlu","Danger":"Button_Danger__3xR6n"};